import APIClient from '@/shared/http/clients/api'

const resourceName = 'schedulingtype'
const APIRegCommon = process.env.APIBaseURLRegulationCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByAreaID = (areaid, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}/area/${areaid}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegCommon}/${resourceName}/${id}`, config)

const SchedulingTypeRepository = {
  GetAll,
  GetAllPaging,
  GetAllByAreaID,
  GetById,
  Create,
  Update,
  Delete
}

export default SchedulingTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/schedulingtype.js